class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = this.querySelector(".menu-drawer");
    this.toggleButton = this.querySelector(".js-drawer-menu");
    this.backdrop = this.querySelector(".menu-drawer-backdrop");

    // reference & binds
    this.sidebarId = "wwkSidebarTop";
    this.sidebarTop = document.getElementById(this.sidebarId);

    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleEsc = this.handleEsc.bind(this);
    this._forceHide = this._forceHide.bind(this);
    this._onDomMut = this._onDomMut.bind(this);

    this._mo = null;

    this.bindElements();
    // this.setDrawerHeight();
  }

  open() {
    this.classList.add("drawer-visible");
    document.body.classList.add("drawer-open");

    let chatClose = document.getElementById("shopify-chat");
    if (chatClose) chatClose.style.visibility = "hidden";

    const teaser = document.querySelector('[data-testid="animated-teaser"]');
    if (teaser) teaser.style.display = "none";

    document.addEventListener("click", this.handleOutsideClick);
    document.addEventListener("keydown", this.handleEsc);

    // 1) initially hide
    this._forceHide();

    // 2)catch all scroll eventds and keep it hidden
    document.addEventListener("scroll", this._forceHide, /* capture */ true);
    window.addEventListener("scroll", this._forceHide, /* capture */ true);

    // observe body
    if (!this._mo) {
      this._mo = new MutationObserver(this._onDomMut);
      this._mo.observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["style", "class"],
      });
    }
  }

  close() {
    this.classList.remove("drawer-visible");
    document.body.classList.remove("drawer-open");

    let chatClose = document.getElementById("shopify-chat");
    if (chatClose) chatClose.style.visibility = "visible";

    const teaser = document.querySelector('[data-testid="animated-teaser"]');
    if (teaser) teaser.style.display = "";

    document.removeEventListener("click", this.handleOutsideClick);
    document.removeEventListener("keydown", this.handleEsc);

    document.removeEventListener("scroll", this._forceHide, true);
    window.removeEventListener("scroll", this._forceHide, true);

    if (this._mo) {
      this._mo.disconnect();
      this._mo = null;
    }

    // revert it when closing drawer
    const el = document.getElementById(this.sidebarId);
    if (el) el.style.display = "block";
  }

  bindElements() {
    if (this.toggleButton) {
      this.toggleButton.addEventListener("click", (e) => {
        e.stopPropagation();
        this.classList.contains("drawer-visible") ? this.close() : this.open();
      });
    }

    if (this.drawer) {
      this.drawer.addEventListener("click", (e) => e.stopPropagation());
    }

    if (this.backdrop) {
      this.backdrop.addEventListener("click", () => this.close());
    }
  }

  handleOutsideClick(event) {
    const clickedInsideDrawer =
      this.drawer && this.drawer.contains(event.target);
    const clickedToggle =
      this.toggleButton && this.toggleButton.contains(event.target);
    if (!clickedInsideDrawer && !clickedToggle) this.close();
  }

  handleEsc(event) {
    if (event.key === "Escape" || event.key === "Esc") this.close();
  }

  setDrawerHeight() {
    const headerGroup = document.querySelector(
      ".shopify-section-group-header-group"
    );
    if (headerGroup) {
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(headerGroup.getBoundingClientRect().bottom)}px`
      );
    } else {
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `54px`
      );
    }
  }

  // ————— Helpers —————

  _forceHide() {
    const el = document.getElementById(this.sidebarId);
    if (!el) return;
    if (document.body.classList.contains("drawer-open")) {
      el.style.display = "none";
    }
  }

  _onDomMut(mutations) {
    for (const m of mutations) {
      if (m.type === "childList" || m.type === "attributes") {
        this._forceHide();
      }
    }
  }
}

customElements.define("menu-drawer", MenuDrawer);

(function () {
  const headerSearch = document.querySelector(".header-search"); 
  const searchToggles = document.querySelectorAll(".js-search-toggle");
  const headerDesktopLogo = document.querySelector(".header__title-desktop");

  if (!headerSearch || !searchToggles.length) return;

  const psClear = headerSearch.querySelector(".ps-clear");
  const psInput =
    headerSearch.querySelector("#ps-input") ||
    headerSearch.querySelector('input[type="search"]');

  // show/hide search icons
  const hideToggles = () =>
    searchToggles.forEach((el) => (el.style.display = "none"));
  const showToggles = () =>
    searchToggles.forEach((el) => (el.style.display = ""));

  // open search
  const openSearch = () => {
    headerSearch.classList.add("is-open");
    if (window.innerWidth > 768) {
      hideToggles();
    }
  };

  // close search
  const closeSearch = () => {
    headerSearch.classList.remove("is-open");
    showToggles();

    const popover = headerSearch.querySelector("#ps-popover");
    if (popover) popover.hidden = true;
    if (psInput) psInput.value = "";
  };

  // open on icons click
  searchToggles.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      openSearch();
      if (headerDesktopLogo) {
        headerDesktopLogo.addEventListener(
          "transitionend",
          function handler(e) {
            if (e.propertyName === "max-width") {
              // ili koja god CSS osobina ima tranziciju
              headerSearch.style.overflow = "unset";

              // skini listener posle prve aktivacije
              headerDesktopLogo.removeEventListener("transitionend", handler);
            }
          }
        );
      }
    });
  });

  // close on close icon click
  if (psClear) {
    psClear.addEventListener("click", (e) => {
      e.preventDefault();
      closeSearch();
    });
  }

  // close on click outside of popup
  document.addEventListener("click", (e) => {
    const clickedToggle = e.target.closest(".js-search-toggle");
    if (clickedToggle) return;
    if (
      headerSearch.classList.contains("is-open") &&
      !headerSearch.contains(e.target)
    ) {
      closeSearch();
    }
  });

  // close on escape
  headerSearch.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeSearch();
  });
})();
